import React from "react";
import { iconStyles } from "./iconStyles";
export function InsightsIcon() {
    return (<svg className={iconStyles} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <path d="M37.4818 8.41074C38.1244 9.00188 38.1765 10.0135 37.5982 10.6704L23.5112 26.6703C23.224 26.9966 22.8182 27.1879 22.389 27.1994C21.9597 27.211 21.5447 27.0418 21.241 26.7314L15.3043 20.6627L4.67199 31.5314C4.06074 32.1562 3.0697 32.1562 2.45844 31.5314C1.84719 30.9065 1.84719 29.8935 2.45844 29.2686L14.1976 17.2686C14.8088 16.6438 15.7999 16.6438 16.4111 17.2686L22.288 23.2762L35.2714 8.52967C35.8496 7.87285 36.8393 7.81961 37.4818 8.41074Z"/>
        </svg>);
}
